import { css } from 'emotion';
import { lightGrey, darkGrey, burnedOrange } from 'inside-out/global-styles';
import OnIcon from 'inside-out/images/drop-down-white-icon.svg';
import OffIcon from 'inside-out/images/drop-down-grey-icon.svg';

export const componentWrapStyle = active => {
	const base = {
		'& > a': {
			borderRadius: '4px',
			fontSize: '16px',
			lineHeight: '22px',
			padding: '5px 10px',
			display: 'inline-block',
			position: 'relative',
			textDecoration: 'none',
			width: '98px',
			boxSizing: 'border-box',
			'&:after': {
				//transition: 'transform 0.125s',
				position: 'absolute',
				top: '50%',
				right: '10px',
				width: '14px',
				height: '9px',
				content: "' '",
				display: 'block',
				transform: 'translateY(-50%)',
			},
		},
		'& > div': {
			position: 'absolute',
			left: '0',
			width: '100%',
		},
	};
	return css({
		...base,
		...(active
			? {
					'& > a ': {
						...base['& > a '],
						color: '#fff',
						border: '1px solid #505E64',
						background: '#505E64',
						'&:after': {
							...base['& > a:after'],
							transform: 'scaleY(-1) translateY(50%)',
							background: `url(${OnIcon}) no-repeat center center`,
						},
					},
					'& > div': {
						...base['& > div'],
						display: 'block',
					},
			  }
			: {
					'& > a ': {
						...base['& > a '],
						border: `1px solid ${lightGrey}`,
						color: darkGrey,
						'&:after': {
							...base['& > a:after'],
							background: `url(${OffIcon}) no-repeat center center`,
						},
					},
					'& > div': {
						...base['& > div'],
						display: 'none',
					},
			  }),
	});
};

export const componentDropDownStyle = top =>
	css({
		top: top,
	});

export const componentBadgeStyle = css({
	display: 'block',
	position: 'absolute',
	width: '14px',
	height: '14px',
	right: '-7px',
	top: '-7px',
	backgroundColor: burnedOrange,
	borderRadius: '50%',
});


// WEBPACK FOOTER //
// ./src/components/shared/filterDropDown/styles.js